"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = (0, tslib_1.__importStar)(require("react"));
var SparkLargeIcon = function (_a) {
    var size = _a.size, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (React.createElement("svg", (0, tslib_1.__assign)({ viewBox: "0 0 28 28", fill: "currentColor", width: size || '28', height: size || '28' }, props),
        React.createElement("path", { fill: "currentColor", d: "M9.928 9.674l3.473-9.26a.64.64 0 0 1 1.197 0l3.472 9.26c.044.117.137.21.254.254l9.26 3.473c.555.206.555.99 0 1.199l-9.26 3.47a.443.443 0 0 0-.254.254l-3.472 9.26a.638.638 0 0 1-1.197 0l-3.473-9.26a.45.45 0 0 0-.254-.254L.414 14.6c-.552-.208-.552-.993 0-1.2l9.26-3.472a.437.437 0 0 0 .254-.254", fillRule: "evenodd" })));
};
SparkLargeIcon.displayName = 'SparkLargeIcon';
exports.default = SparkLargeIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SparkLargeIcon.js.map